module.exports = __webpack_public_path__ + "static/img/zhongzhongka3.bb4827c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zhongzhongka3.png
// module id = C7ER
// module chunks = 16